(function(){
  // ====== CONFIG ======
  const TIMEOUT_MS = 600;
  const SUGGEST_LIMIT = 10;
  const SCORE_THRESHOLD = 80; // tu peux monter à 88-90 pour être plus strict

  // ====== Utils texte ======
  function simplify(s){
    return String(s||'')
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'') // accents
      .replace(/['’]/g,' ')                             // apostrophes
      .replace(/[^a-z0-9]+/gi,' ')                      // non alnum -> espace
      .toLowerCase().trim().replace(/\s+/g,' ');
  }
  function toHandleLike(s){ return simplify(s).replace(/\s+/g,'-'); }

  // Écrase les doubles lettres: trottinette -> trotinet e (pour comparer sans “gémination”)
  function degeminate(s){
    return String(s||'').replace(/([a-z])\1+/gi,'$1');
  }

  // règles FR (sing/plur)
  const EXCEPT_OU = new Set(['bijou','caillou','genou','hibou','joujou','pou']);
  const EXCEPT_AL_AUX_KEEP_AL = new Set(['bal','carnaval','festival','recital','chacal','regal','banal','fatal','natal','naval']);

  function toSingular(w){
    if (w.endsWith('eaux')) return w.slice(0,-1);
    if (w.endsWith('aux')) { const cand = w.slice(0,-3)+'al'; if (!EXCEPT_AL_AUX_KEEP_AL.has(cand)) return cand; }
    if (w.endsWith('x')) { const root = w.slice(0,-1)+'u'; if (EXCEPT_OU.has(root)) return root; }
    if (/[sxz]$/.test(w)) return w.replace(/[sxz]$/,'');
    return w;
  }
  function toPlural(w){
    if (w.endsWith('eau')) return w+'x';
    if (w.endsWith('al') && !EXCEPT_AL_AUX_KEEP_AL.has(w)) return w.slice(0,-2)+'aux';
    if (w.endsWith('ou')) return EXCEPT_OU.has(w) ? w+'x' : w+'s';
    if (/[sxz]$/.test(w)) return w;
    return w+'s';
  }
  function variants(phrase){
    const s = simplify(phrase);
    if (!s) return [];
    const out = new Set([s]);
    const words = s.split(' ');

    // tout singulier / tout pluriel
    out.add(words.map(toSingular).join(' '));
    out.add(words.map(toPlural).join(' '));

    // variantes ciblées
    if (words.length>1){
      out.add(words.slice(0,-1).concat(toSingular(words.at(-1))).join(' '));
      out.add(words.slice(0,-1).concat(toPlural(words.at(-1))).join(' '));
      out.add([toSingular(words[0])].concat(words.slice(1)).join(' '));
      out.add([toPlural(words[0])].concat(words.slice(1)).join(' '));
    }

    // version "handle-like"
    Array.from(out).forEach(v => out.add(v.replace(/\s+/g,'-')));

    // variantes "dé-géminées"
    Array.from(out).forEach(v => out.add(degeminate(v)));

    return Array.from(out);
  }

  // ====== Jaro-Winkler (fuzzy rapide) ======
  function jw(a,b){
    if (a===b) return 1;
    const maxDist = Math.floor(Math.max(a.length,b.length)/2)-1;
    let mA = new Array(a.length).fill(false);
    let mB = new Array(b.length).fill(false);
    let matches=0, trans=0;

    for (let i=0;i<a.length;i++){
      const start = Math.max(0, i - maxDist);
      const end   = Math.min(i + maxDist + 1, b.length);
      for (let j=start;j<end;j++){
        if (mB[j]) continue;
        if (a[i] === b[j]) { mA[i]=mB[j]=true; matches++; break; }
      }
    }
    if (!matches) return 0;

    let k=0;
    for (let i=0;i<a.length;i++){
      if (!mA[i]) continue;
      while (!mB[k]) k++;
      if (a[i] !== b[k]) trans++;
      k++;
    }
    const m = matches;
    let jaro = (m/a.length + m/b.length + (m - trans/2)/m)/3;

    // bonus de préfixe (Winkler)
    let l = 0;
    const maxPrefix = Math.min(4, Math.min(a.length, b.length));
    while (l<maxPrefix && a[l]===b[l]) l++;
    return jaro + l*0.1*(1-jaro);
  }

  // ====== Damerau-Levenshtein borné (≤2) ======
  // Retourne 0,1,2 ou >limit (3+) avec sortie anticipée pour la perf.
  function dlBounded(a,b,limit=2){
    if (a===b) return 0;
    const la=a.length, lb=b.length;
    if (Math.abs(la-lb)>limit) return limit+1;

    // matrices 2 lignes + dictionnaire dernière position (Damerau)
    const INF = la+lb;
    const da = Object.create(null);
    const max = Math.max(la, lb);
    const v0 = new Array(lb+2).fill(0);
    const v1 = new Array(lb+2).fill(0);
    const v2 = new Array(lb+2).fill(0);

    const bound = limit;

    const db = new Array(256).fill(0); // positions des caractères b
    const ALPH = 256;

    // Initialisation selon l'algorithme optimal string alignment modifié
    let cost, i1, j1, k, l;

    const d = [];
    for (let i=0;i<=la;i++){
      d[i] = new Array(lb+1);
      d[i][0] = i;
    }
    for (let j=0;j<=lb;j++){
      d[0][j] = j;
    }

    for (let i=1;i<=la;i++){
      let rowMin = INF;
      for (let j=1;j<=lb;j++){
        cost = (a[i-1]===b[j-1]) ? 0 : 1;
        const del = d[i-1][j] + 1;
        const ins = d[i][j-1] + 1;
        const sub = d[i-1][j-1] + cost;
        let val = Math.min(del, ins, sub);

        if (i>1 && j>1 && a[i-1]===b[j-2] && a[i-2]===b[j-1]){
          val = Math.min(val, d[i-2][j-2] + 1); // transposition
        }
        d[i][j] = val;
        if (val < rowMin) rowMin = val;
      }
      // sortie anticipée : si toute la ligne dépasse la borne
      if (rowMin > bound) return bound+1;
    }
    return d[la][lb];
  }

  // ====== Scoring requête ↔ collection ======
  function scoreQueryToCollection(qNorm, col){
    // col: {title, handle, url}
    const titleNorm  = simplify(col.title||'');
    const handleNorm = simplify(String(col.handle||'').replace(/-/g,' '));

    // sac de formes pour comparaisons exactes / prefix / contains
    const bag = new Set([
      titleNorm,
      handleNorm,
      toHandleLike(col.title||''),
      String(col.handle||'').toLowerCase(),
      // formes dé-géminées (ex: trottinette -> trotinet e)
      degeminate(titleNorm),
      degeminate(handleNorm),
      degeminate(toHandleLike(col.title||'')),
      degeminate(String(col.handle||'').toLowerCase())
    ]);

    // exact
    const qHandleish = qNorm.replace(/\s+/g,'-');
    if (bag.has(qNorm) || bag.has(qHandleish) || bag.has(degeminate(qNorm)) || bag.has(degeminate(qHandleish)))
      return 100;

    // recoupes
    const stop = new Set(['de','du','des','la','le','les','et','pour','un','une','au','aux','en','sur','avec','à','a']);
    const qTokens = qNorm.split(' ').filter(t=>t && !stop.has(t));
    const tTokens = titleNorm.split(' ').filter(t=>t && !stop.has(t));
    const overlap = qTokens.filter(t => tTokens.includes(t)).length;
    const overlapPct = tTokens.length ? Math.round(100*overlap/Math.max(tTokens.length,qTokens.length)) : 0;

    const starts   = [...bag].some(x => x.startsWith(qNorm) || x.startsWith(degeminate(qNorm)));
    const contains = [...bag].some(x => x.includes(qNorm) || x.includes(degeminate(qNorm)));

    // fuzzy (sur versions compactées)
    const qC = qNorm.replace(/\s+/g,'');
    const cC = titleNorm.replace(/\s+/g,'');
    const fuzzy = Math.round(jw(qC, cC)*100);

    // Damerau-Levenshtein borné (capte double consonne manquante)
    const dl = dlBounded(qC, cC, 2);
    const qCd = degeminate(qC), cCd = degeminate(cC);
    const dlDeg = dlBounded(qCd, cCd, 2);

    // agrégation pondérée
    let s = 0;
    s += overlapPct * 0.55;
    s += (starts? 20:0) + (contains? 8:0);
    s += Math.min(fuzzy, 85) * 0.28;

    // bonus DL (fort si ≤1, léger si =2), on prend le meilleur des 2 (normal vs dé-géminé)
    const bestDl = Math.min(dl, dlDeg);
    if (bestDl <= 1) s = Math.max(s, 92);       // cas “trotinette” vs “trottinette”
    else if (bestDl === 2) s += 6;

    return Math.min(100, Math.round(s));
  }

  function findBestCollectionMatch(searchTerm, collections){
    const v = variants(searchTerm);
    let best=null, bestScore=-1;

    for (const col of collections){
      let localBest=-1;
      for (const q of v){
        const s = scoreQueryToCollection(simplify(q), col);
        if (s>localBest) localBest=s;
        if (localBest>=100) break;
      }
      if (localBest>bestScore){
        bestScore=localBest; best=col;
      }
    }
    if (best && bestScore>=SCORE_THRESHOLD) return {best, bestScore};
    return {best:null, bestScore};
  }

  // ====== Intégration formulaire ======
  function enhance(){
    const forms = document.querySelectorAll('form[action="/search"]');
    if (!forms.length) return;

    forms.forEach(form=>{
      form.addEventListener('submit', async function(e){
        const input = form.querySelector('input[name="q"]');
        if (!input) return;
        const raw = input.value.trim();
        if (!raw) return;

        e.preventDefault();

        // Suggest Shopify (collections uniquement)
        const url = `/search/suggest.json?q=${encodeURIComponent(raw)}&resources[type]=collection&resources[limit]=${SUGGEST_LIMIT}`;
        let collections = [];
        try{
          const ctrl = new AbortController();
          const tm = setTimeout(()=>ctrl.abort(), TIMEOUT_MS);
          const r = await fetch(url, {signal: ctrl.signal});
          clearTimeout(tm);
          const data = await r.json();
          collections = (data?.resources?.results?.collections || [])
            .map(c => ({title:c.title, handle:c.handle, url:c.url}));
        }catch(e){ /* ignore */ }

        const {best, bestScore} = findBestCollectionMatch(raw, collections);
        if (best && best.url){
          window.location.href = best.url;
        } else {
          window.location.href = `/search?q=${encodeURIComponent(raw)}`;
        }
      }, {passive:false});
    });
  }

  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
})();